export default __webpack_public_path__ + "static/media/traffic-signal-error.8cdc04b9.svg";